import pseudoComponents from '../../config/pseudo-components.json'
import { type JsonPseudoComponentsConfig } from './types'

export const getConfig = () => {
  return pseudoComponents as JsonPseudoComponentsConfig[]
}
